import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button";
import {borderRadius, calculateRemSize as crs, p} from "@pg-design/helpers-css";

import {IRadioProps, Radio} from "./Radio";

type IProps = IRadioProps & {
    value: string | number | boolean;
    buttonType?: "radio" | "button";
    className?: string;
    buttonClassName?: string;
};

export function RadioButton(props: IProps) {
    const {name, id, value, isActive, buttonType = "button", buttonClassName, ...inputProps} = props;

    if (buttonType === "button") {
        return (
            <>
                <input
                    {...inputProps}
                    type="radio"
                    name={name}
                    id={id}
                    value={value}
                    readOnly={props.readOnly}
                    onChange={({currentTarget: {checked, value, name}}) => {
                        if (!props.readOnly && props.onChange) {
                            props.onChange(name, checked, value);
                        }
                    }}
                    hidden
                    aria-hidden
                />
                <label htmlFor={id} css={buttonTypeWrap}>
                    <ButtonRadio
                        className={buttonClassName}
                        variant="outlined_secondary"
                        isSelected={Boolean(isActive)}
                        onClick={() => {
                            if (!props.readOnly && props.onChange) {
                                props.onChange(name, !isActive, value);
                            }
                        }}
                        type="button"
                    >
                        {props.labelContent}
                    </ButtonRadio>
                </label>
            </>
        );
    }

    return (
        <RadioWrap
            className={buttonClassName}
            isSelected={Boolean(props.isActive)}
            onClick={(e) => {
                if ((e.target as HTMLElement).nodeName !== "INPUT" && (e.target as HTMLElement).nodeName !== "LABEL" && props.onChange) {
                    props.onChange(props.name, true, props.value as HTMLInputElement["value"]);
                }
            }}
        >
            <Radio {...inputProps} isActive={isActive} name={name} id={id} value={value} />
        </RadioWrap>
    );
}

// Style
const RadioWrap = styled.div<{isSelected: boolean}>`
    ${({theme, isSelected}) => css`
        background: ${theme.colors.gray[100]};
        ${p(1, 2, 1, 1)};
        ${borderRadius(1)};
        position: relative;
        cursor: pointer;
        border: 1px solid transparent;
        display: flex;
        align-items: center;

        ${isSelected &&
        css`
            border: 1px solid ${theme.colors.gray[500]};
        `}
    `}
`;

const ButtonRadio = styled(Button)<{isSelected: boolean}>`
    ${({isSelected, theme}) => css`
        height: ${crs(5)};
        min-width: auto;
        flex: 1 1 auto;

        ${isSelected
            ? css`
                  background: ${theme.colors.primary};
              `
            : ""}

        &:focus-visible {
            outline: none;
        }
    `}
`;

const buttonTypeWrap = css`
    flex: 1 1 auto;
    display: flex;
`;
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button";
import {borderRadius, calculateRemSize as crs, p} from "@pg-design/helpers-css";

import {IRadioProps, Radio} from "./Radio";

type IProps = IRadioProps & {
    value: string | number | boolean;
    buttonType?: "radio" | "button";
    className?: string;
    buttonClassName?: string;
};

export function RadioButton(props: IProps) {
    const {name, id, value, isActive, buttonType = "button", buttonClassName, ...inputProps} = props;

    if (buttonType === "button") {
        return (
            <>
                <input
                    {...inputProps}
                    type="radio"
                    name={name}
                    id={id}
                    value={value}
                    readOnly={props.readOnly}
                    onChange={({currentTarget: {checked, value, name}}) => {
                        if (!props.readOnly && props.onChange) {
                            props.onChange(name, checked, value);
                        }
                    }}
                    hidden
                    aria-hidden
                />
                <label htmlFor={id} css={buttonTypeWrap}>
                    <ButtonRadio
                        className={buttonClassName}
                        variant="outlined_secondary"
                        isSelected={Boolean(isActive)}
                        onClick={() => {
                            if (!props.readOnly && props.onChange) {
                                props.onChange(name, !isActive, value);
                            }
                        }}
                        type="button"
                    >
                        {props.labelContent}
                    </ButtonRadio>
                </label>
            </>
        );
    }

    return (
        <RadioWrap
            className={buttonClassName}
            isSelected={Boolean(props.isActive)}
            onClick={(e) => {
                if ((e.target as HTMLElement).nodeName !== "INPUT" && (e.target as HTMLElement).nodeName !== "LABEL" && props.onChange) {
                    props.onChange(props.name, true, props.value as HTMLInputElement["value"]);
                }
            }}
        >
            <Radio {...inputProps} isActive={isActive} name={name} id={id} value={value} />
        </RadioWrap>
    );
}

// Style
const RadioWrap = styled.div<{isSelected: boolean}>`
    ${({theme, isSelected}) => css`
        background: ${theme.colors.gray[100]};
        ${p(1, 2, 1, 1)};
        ${borderRadius(1)};
        position: relative;
        cursor: pointer;
        border: 1px solid transparent;
        display: flex;
        align-items: center;

        ${isSelected &&
        css`
            border: 1px solid ${theme.colors.gray[500]};
        `}
    `}
`;

const ButtonRadio = styled(Button)<{isSelected: boolean}>`
    ${({isSelected, theme}) => css`
        height: ${crs(5)};
        min-width: auto;
        flex: 1 1 auto;

        ${isSelected
            ? css`
                  background: ${theme.colors.primary};
              `
            : ""}

        &:focus-visible {
            outline: none;
        }
    `}
`;

const buttonTypeWrap = css`
    flex: 1 1 auto;
    display: flex;
`;
